<script>
    import { user } from '../stores/login_store.js'
    import page from 'page'
    export let file = null

    const extend_expiration = async () => {
        await fetch(
            `/api/files/${file.file.file_id}/extend`,
            { credentials: 'include' }
        )

        location.href = `/download/${file.file.file_id.replace('file_', '')}`
    }

    const delete_file = async () => {
        await fetch(
            `/api/files/download/${file.file.file_id}`,
            { credentials: 'include', method: 'delete'}
        )

        page('/')
    }
</script>

{#if $user && file && file.file.user_id === $user.user_id}
<div class="box block">

    <div class="level">
        <div class="level-left">Ownership controls</div>
        <div class="level-right">
            <div class="buttons">
                <button
                    on:click={extend_expiration}
                    class="button">
                    Extend timeout
                </button>
                <button
                    on:click={delete_file}
                    class="button is-danger">
                    Delete file
                </button>
            </div>
        </div>
    </div>
    
</div>
{/if}
